import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  // DropdownItem,
} from "reactstrap";

//i18n
// import { withTranslation } from "react-i18next";
// Redux
import { Link, useNavigate } from "react-router-dom";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";
import { removeDataLocalStorage } from "src/helpers/auth_helper";
import { toast } from "react-toastify";

//redux
// import { useSelector } from "react-redux";
// import { createSelector } from "reselect";

const ProfileMenu = (props: any) => {
  // const { success } = useSelector((state: any) => ({
  //   success: state.profile.success,
  // }));

  // const profiledata = createSelector(

  //   (state: any) => state.profile,
  //   (state) => ({
  //     success: state.success,
  //   })
  // );
  // Inside your component
  // const { success } = useSelector(profiledata);

  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState<boolean>(false);
  const navigate = useNavigate();
  // const [username, setusername] = useState("Admin");

  // useEffect(() => {
  //   const getAuthUser = localStorage.getItem("authUser");
  //   if (getAuthUser) {
  //     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
  //       const obj = JSON.parse(getAuthUser);
  //       setusername(obj.displayName);
  //     } else if (
  //       process.env.REACT_APP_DEFAULTAUTH === "fake" ||
  //       process.env.REACT_APP_DEFAULTAUTH === "jwt"
  //     ) {
  //       const obj = JSON.parse(getAuthUser);
  //       setusername(obj.username);
  //     }
  //   }
  // }, [success]);
  const onCommingSoon = () => {
    toast("Comming Soon", { type: "info", hideProgressBar:true, autoClose: 2000 });
  }

  const onLogout = () => {
    removeDataLocalStorage();
    navigate("/login")
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item bg-soft-light border-start border-end"
          id="page-header-user-dropdown"
          tag="button"
        >
          {/* <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          /> */}
          <div className="d-flex justify-content-center align-content-center">
            <div className="bg-primary rounded-circle d-flex justify-content-center align-items-center " style={{ width: '30px', height: '30px'}}>
              <span className="fw-bold">A</span>
            </div>
            <div className="d-flex align-items-center">
              <span className="fw-medium mx-2">Admin</span>
              <i className="mdi mdi-chevron-down d-xl-inline-block" />
            </div>
          </div>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">

          <button onClick={onCommingSoon} className="dropdown-item">
            <i className="mdi mdi mdi-face-man font-size-16 align-middle me-1"></i>{" "}
            Profile
          </button>{" "}

          {/* <Link to="/page-lock-screen" className="dropdown-item">
            <i className="mdi mdi-lock font-size-16 align-middle me-1"></i>
            {props.t("Lock screen")}
          </Link> */}

          <div className="dropdown-divider" />
          <button onClick={onLogout} className="dropdown-item">
            <i className="mdi mdi-logout font-size-16 align-middle me-1"></i>
            <span>Logout</span>
          </button>

        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};
export default ProfileMenu;
